import { useEffect, useState } from "react";

const KEY = "gm_cookie_consent_v1";

export default function CookieBanner() {
  const [state, setState] = useState(null);
  const [custom, setCustom] = useState(false);
  const [prefs, setPrefs] = useState({ necessary: true, analytics: false, marketing: false });

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) setState("show");
      else setState("hidden");
    } catch { setState("show"); }
  }, []);

  const save = (choice) => {
    try { localStorage.setItem(KEY, JSON.stringify({ ...choice, ts: Date.now() })); } catch {}
    setState("hidden");
  };

  if (state !== "show") return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[80] bg-ink text-bone border-t border-gold/40" data-testid="cookie-banner">
      <div className="container-x py-6 grid md:grid-cols-12 gap-4 items-center">
        <div className="md:col-span-7">
          <div className="eyebrow text-gold">Privacy & Cookie</div>
          <p className="mt-2 text-sm text-bone/80 font-light leading-relaxed">
            Utilizziamo cookie tecnici e, con il tuo consenso, cookie di analisi per capire come viene utilizzato il sito. Puoi accettare tutto, rifiutare i non necessari o personalizzare le scelte. Trovi maggiori dettagli nella{" "}
            <a href="/privacy" className="underline hover:text-gold">Privacy Policy</a>{" "}
            e nella{" "}
            <a href="/cookie" className="underline hover:text-gold">Cookie Policy</a>.
          </p>
          {custom && (
            <div className="mt-4 space-y-2 text-xs">
              <label className="flex items-center gap-3 opacity-70">
                <input type="checkbox" checked disabled /> Necessari (sempre attivi)
              </label>
              <label className="flex items-center gap-3">
                <input type="checkbox" checked={prefs.analytics} onChange={(e)=>setPrefs({...prefs, analytics: e.target.checked})} /> Analisi statistiche
              </label>
              <label className="flex items-center gap-3">
                <input type="checkbox" checked={prefs.marketing} onChange={(e)=>setPrefs({...prefs, marketing: e.target.checked})} /> Marketing e re-targeting
              </label>
            </div>
          )}
        </div>
        <div className="md:col-span-5 flex flex-wrap gap-2 md:justify-end">
          {!custom && (
            <button onClick={()=>setCustom(true)} className="px-4 py-2 text-xs tracking-[0.14em] uppercase border border-bone/40 hover:border-bone" data-testid="cookie-customize">Personalizza</button>
          )}
          <button onClick={()=>save({ necessary:true, analytics:false, marketing:false })} className="px-4 py-2 text-xs tracking-[0.14em] uppercase border border-bone/40 hover:border-bone" data-testid="cookie-reject">Rifiuta</button>
          <button onClick={()=>save(custom ? { necessary:true, ...prefs } : { necessary:true, analytics:true, marketing:true })} className="px-5 py-2 text-xs tracking-[0.14em] uppercase bg-bone text-ink hover:bg-gold hover:text-bone" data-testid="cookie-accept">
            {custom ? "Salva Preferenze" : "Accetta Tutto"}
          </button>
        </div>
      </div>
    </div>
  );
}
